import { get } from 'api/apiRequest';
import { ServerExhibitType } from './actions-select-options';
import { ActionStatus, ClaimEditChangeOptionsMarkFlags } from './claims';

export type ActionStatusDynamic = {
  id: string;
  actionStatus: ActionStatus;
  actionExhibitTypes: ServerExhibitType[];
  actionStatusDisplayName: string;
};

export interface ActionStatusLabel {
  id: number;
  actionStatusId: number;
  actionStatus: string;
  transactionApproverLabel: string;
  transactionProposerLabel: string;
  transactionApproverFlag: keyof ClaimEditChangeOptionsMarkFlags;
  transactionProposerFlag: keyof ClaimEditChangeOptionsMarkFlags;
  // createdBy: string;
  // createdDate: string;
  // updatedBy: string;
  // updatedDate: string;
}

export const actionStatus = {
  getActionStatusList: async () => {
    return await get<ActionStatusDynamic[]>('v1/Claims/workflowstatus');
  },
  getDynamicLabels: () =>
    get<ActionStatusLabel[]>(`v1/Claims/getActionStatusDynamicLabels`),
};
